<template>
  <div v-if="item">
      <h4>Общая стоимость: {{item.price * item.quantity | spaceBetweenNumber}} сум</h4>
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "purchases",
    cardSetLink: "purchases",
    item: null,
    fields: [
        {
        col:' col-12 col-md-12',
        key: "display_name",
        label: "Название товара",
        type: "field",
        textType: "text",
        readonly:true
      },
      {
        col:' col-12 col-md-6',
        key: "price",
        label: "Цена за 1 ед. (сум)",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "quantity",
        label: "Количество",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-6',
        key: "reward",
        label: "Награда за 1 ед. (сум)",
        type: "field",
        textType: "number",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
